@if (estado?.tienePin || hecho) {
  <div class="employee-editor-page__support employee-editor-page__support--soft pin-restablecer">
    <i class="material-icons" aria-hidden="true">dialpad</i>
    <div class="employee-editor-page__support-copy">
      <strong>PIN de autorización</strong>
      @if (estado?.tienePin) {
        <span>
          @if (estado?.bloqueadoHasta) {
            Bloqueado hasta las {{ estado?.bloqueadoHasta }} por intentos fallidos.
          } @else {
            Definido.
          }
          Nadie lo puede ver. Restablecerlo lo borra: la persona define uno nuevo en Ajustes, con su contraseña de COS.
        </span>
        <button type="button" class="pin-restablecer__btn" [disabled]="enviando" (click)="restablecer()">
          {{ enviando ? "Restableciendo…" : "Restablecer PIN de autorización" }}
        </button>
      } @else {
        <span role="status">{{ hecho }}</span>
      }
    </div>
  </div>
}
